// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions"> <ex-mono-occurrence-ecran-bas> <ex-card-multi-advanced ex-bloc="evq" lbl-titre="LBL_BLC_EVQ" multi-occurrence-options="vm.evqMultiOccurrenceOptions"> </ex-card-multi-advanced> </ex-mono-occurrence-ecran-bas> </ex-mono-occurrence-ecran>`;
// Exports
module.exports = code;